<template>
  <v-card class="candidate dashboard-invites mt-4" v-show="!loading && invites.length">
    <v-card-title class="pt-4" :class="themes.candidate.light.dialogTitle">
      <div>
        <div class="title">Open Invites</div>
        <div class="subheading" :class="themes.candidate.light.cardSubtitle">
          Opportunities where you have been invited to apply
        </div>
      </div>
    </v-card-title>

    <v-card-text>
      <v-list avatar>
        <v-list-tile v-for="(eligibility, i) in invites" :key="`invite-${eligibility.id}`" class="mb-2">
          <v-list-tile-avatar>
            <v-avatar slot="activator" size="50">
              <img :src="eligibility.opportunity.organization.logo" />
            </v-avatar>
          </v-list-tile-avatar>
          <v-list-tile-content>
            <v-list-tile-title> {{ eligibility.opportunity.name }} </v-list-tile-title>
            <v-list-tile-sub-title>
              {{ eligibility.opportunity.organization.name }}
            </v-list-tile-sub-title>
          </v-list-tile-content>
          <v-list-tile-action>
            <v-btn
              :color="themes.candidate.light.secondaryActionButton"
              :to="`/opportunities/${eligibility.opportunity.id}`"
            >
              View
            </v-btn>
          </v-list-tile-action>
        </v-list-tile>
      </v-list>
    </v-card-text>
  </v-card>
</template>

<script>
// Helpers
import { mapActions, mapGetters } from 'vuex'
import _ from 'lodash'

// Vue Component
export default {
  created() {
    this.$store.dispatch('candidate/invites/fetchAll').finally(() => this.loading = false)
  },
  data() {
    return {
      loading: true,
    }
  },
  computed: {
    ...mapGetters({
      invites: 'candidate/invites/all',
    }),
  },
}
</script>

<style>
div.v-list__tile {
  padding-right: 5px;
}
</style>
